module.exports = __webpack_public_path__ + "img/200G.a88c10e8.png";